import React from 'react';

const ChequeredPromotion: React.FC = () => {
    return (
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-200 rounded-lg p-6 sm:p-8">
            <div className="text-center space-y-4">
                {/* Icon */}
                <div className="flex justify-center">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" className="sm:w-10 sm:h-10 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 2l2 4h4l-3 3 1 4-4-2-4 2 1-4-3-3h4z"></path>
                            <rect x="2" y="14" width="20" height="8" rx="1"></rect>
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <div>
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
                        Chequered Chess Training Platform
                    </h3>
                    <p className="text-sm sm:text-base text-amber-600 font-semibold">
                        🔒 Feature Not Enabled
                    </p>
                </div>

                {/* Description */}
                <div className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
                    <p className="text-sm sm:text-base text-gray-700 mb-4 leading-relaxed">
                        <strong>Chequered</strong> is our comprehensive chess training platform designed for coaches and students. 
                        Teach chess effectively with interactive tools, puzzles, and real-time collaboration features.
                    </p>
                    
                    {/* Features List */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left mb-4">
                        <div className="flex items-start gap-2">
                            <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span className="text-sm text-gray-700">Interactive chess board</span>
                        </div>
                        <div className="flex items-start gap-2">
                            <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span className="text-sm text-gray-700">Puzzle library & custom puzzles</span>
                        </div>
                        <div className="flex items-start gap-2">
                            <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span className="text-sm text-gray-700">Live teaching mode</span>
                        </div>
                        <div className="flex items-start gap-2">
                            <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span className="text-sm text-gray-700">Share board in video calls</span>
                        </div>
                        <div className="flex items-start gap-2">
                            <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span className="text-sm text-gray-700">Stockfish engine analysis</span>
                        </div>
                        <div className="flex items-start gap-2">
                            <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span className="text-sm text-gray-700">Student progress tracking</span>
                        </div>
                    </div>
                </div>

                {/* CTA Section */}
                <div className="bg-gradient-to-r from-amber-100 to-orange-100 rounded-lg p-4 sm:p-5 border border-amber-200">
                    <p className="text-sm sm:text-base text-gray-800 font-medium mb-3">
                        ♟️ Want to enable Chequered for your chess academy?
                    </p>
                    <p className="text-xs sm:text-sm text-gray-700 mb-4">
                        Reach out to the HoSaksham team to get a demo and unlock the full power of chess training.
                    </p>
                    
                    {/* Contact Options */}
                    <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
                        <a 
                            href="mailto:support@hosaksham.com"
                            className="inline-flex items-center gap-2 px-4 py-2.5 bg-white border-2 border-amber-500 text-amber-600 rounded-lg font-medium hover:bg-amber-50 transition-colors w-full sm:w-auto justify-center"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                <polyline points="22,6 12,13 2,6"></polyline>
                            </svg>
                            <span>support@hosaksham.com</span>
                        </a>
                        <a 
                            href="tel:+916363994715"
                            className="inline-flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-amber-500 to-orange-600 text-white rounded-lg font-medium hover:from-amber-600 hover:to-orange-700 transition-all shadow-md hover:shadow-lg w-full sm:w-auto justify-center"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                            </svg>
                            <span>+91 6363994715</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChequeredPromotion;
